import Actions from '../layouts/actions';

/** Shared row for reviewing several list items. The caller supplies its own fields and optional media. */
export default function ListItemReview({index, title, preview, handle, actions, status, error, onRetry, children}) {
    return <div className="flex items-start gap-3 border-b border-gray-200 py-3 last:border-b-0">
        {handle ? <div className="shrink-0 pt-1">{handle}</div> : null}
        {preview ? <div className="w-14 shrink-0 overflow-hidden rounded bg-gray-50">{preview}</div> : null}
        <div className="flex-1 min-w-0 space-y-2">
            <div className="flex items-center justify-between gap-2 min-h-[2rem]">
                <span className={`truncate text-xs ${error ? 'text-error-700' : 'text-gray-500'}`} title={title}
                    role={error ? 'alert' : undefined}>{status || title || `Item ${index + 1}`}</span>
                {onRetry ? <Actions header actions={[{label: 'Retry', link: true, onClick: onRetry}]}/> : null}
                {actions ? <div className="shrink-0">{actions}</div> : null}
            </div>
            <div className="grid gap-2" style={{gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 11rem), 1fr))'}}>{children}</div>
        </div>
    </div>;
}
